'use strict';/* global define */define('modules/time/filters/lls-duration/index',['require','exports','module'],function(require,exports,module){'use strict';// @ngInject
     filter.$inject = ["$filter", "moment"];
function filter($filter,moment){// jshint validthis:true
// jshint latedef:false
var translate=$filter('translate');var translations={singleDay:translate('ADMIN.FEEDBACK_PERIODS.DURATION_TYPE.DAY'),multipleDays:translate('ADMIN.FEEDBACK_PERIODS.DURATION_TYPE.DAYS')};/**
     * Date filter
     *
     * @param  {Date} date     - Date object
     * @param  {String} format - Provided format
     *
     * @return {String}        - Formatted date string
     *
     * @tested
     */return function(durationString){var duration=moment.duration(durationString);var days=duration.asDays();var translation=days===1?translations.singleDay:translations.multipleDays;return days+' '+translation;};}module.exports=filter;});
